var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import styled from '@emotion/styled';
var Title = styled.h1(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 2.5rem;\n  font-weight: normal;\n  margin: 0 0 1.43rem;\n"], ["\n  font-size: 2.5rem;\n  font-weight: normal;\n  margin: 0 0 1.43rem;\n"])));
var Subtitle = styled.h2(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 1.75rem;\n  font-weight: bolder;\n  margin-bottom: 1.43rem;\n  margin-top: 0;\n"], ["\n  font-size: 1.75rem;\n  font-weight: bolder;\n  margin-bottom: 1.43rem;\n  margin-top: 0;\n"])));
var Account = styled.h3(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-size: 1.5rem;\n  color: ", ";\n  text-transform: uppercase;\n  margin: 0px 0px 8px 0px;\n"], ["\n  font-size: 1.5rem;\n  color: ", ";\n  text-transform: uppercase;\n  margin: 0px 0px 8px 0px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary;
});
var Currency = styled.h4(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  font-size: 1.2rem;\n  color: ", ";\n  text-transform: uppercase;\n  margin: 0px;\n"], ["\n  font-size: 1.2rem;\n  color: ", ";\n  text-transform: uppercase;\n  margin: 0px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary;
});
export var AccountBlock = function (_a) {
    var appName = _a.appName, userName = _a.userName, accountName = _a.accountName, currency = _a.currency, _b = _a.testId, testId = _b === void 0 ? 'account-block' : _b, props = __rest(_a, ["appName", "userName", "accountName", "currency", "testId"]);
    return (<div {...props}>
      <Title data-testid={"".concat(testId, "-title")}>{appName}</Title>
      <Subtitle data-testid={"".concat(testId, "-sub-title")}>Welcome {userName}</Subtitle>
      <Account data-testid={"".concat(testId, "-account")}>{accountName}</Account>
      <Currency data-testid={"".concat(testId, "-currency")}>Account currency: {currency}</Currency>
    </div>);
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
